import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import CoinNetworkPlan from '@/views/Settings/CoinNetworkPlan/CoinNetworkPlan.vue';

import { Route } from '../route.model';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';

const validateRouteFlag = () => {
  return (
    app.$store.getters['business/getBusinessInfo'] &&
    app.$store.getters['business/getBusinessInfo'].business &&
    app.$store.getters['business/getBusinessInfo'].business
      .subscriptionStatus !== EBillingStatusTypes.UNAVAILABLE &&
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV2)
  );
};

const coinNetworkPlan = new Route(
  '/coin-network-plan',
  'coin-network-plan',
  CoinNetworkPlan,
  {
    requiresAuth: true,
    onlyManager: true,
    customFlagValidator: validateRouteFlag,
    isResponsive: flagKeys.responsiveDashboard,
    navbar: {
      name: 'Coin Network Plan',
      icon: 'manage-locations'
    },
    pageView: {
      eventLabel: 'Coin Network Plan'
    }
  }
);

export { coinNetworkPlan };
export default coinNetworkPlan;
